import React from 'react';

import { Oval } from 'react-loader-spinner'
import {
    InputGroupAddon,
    Input,
    InputGroup,
    Button,
    FormGroup,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Row,
    Col,
    Form,
    Spinner,
    Card, CardHeader, CardBody, CardText,
    Navbar,
    Nav,
    NavLink,
    CustomInput
} from 'reactstrap';
import NavBar from '../NavBar/navBar'
import { NavLink as RRNavLink } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import ReactTable from "react-table";
import Select from "react-select";
import { connect } from "react-redux";
import eyeIcon from '../../assets/eye.svg'
import listIcon from '../../assets/list.svg'
import filterOnIcon from '../../assets/filter-enable.svg'
import filterOffIcon from '../../assets/filter-disable.svg'
import filterClearIcon from '../../assets/clear-filter.svg'
import downloadIcon from '../../assets/download.svg'
import uploadIcon from '../../assets/upload.svg'
import deleteIcon from '../../assets/delete.svg'
import deleteIconRed from '../../assets/delete-red-outline.svg'
import editIcon from '../../assets/edit.svg'
import {
    fetchSamplesList,
    fetchLocationList,
    saveSample,
    updateSample,
    deleteSample,
    fetchBuilding,
    fetchFloors,
    downloadSampleData,
    uploadSamples,
    deleteMultipleSamples,
    singleResultUpload,
    fetchAcceptanceCriteria
} from '../../actions';
import Pagination from '../Pagination/pagination'
import { toast, ToastContainer } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faCalendar, faTrashAlt, faArrowsAltV, faUpload, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";
import 'react-confirm-alert/src/react-confirm-alert.css';
import "react-toastify/dist/ReactToastify.css";
import './sample.css';
import template from '../../assets/Samples_Template.xlsx';
import Scanner from '../BarcodeScanner/barcodeScanner'
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from "../../AppInsights";
import { SeverityLevel } from '@microsoft/applicationinsights-common';
import Tour from '../../Tour';
import CustomToolTip from '../SubComponents/CustomTooltip/customTooltip'

let building = sessionStorage.getItem("building")
let buildingId = sessionStorage.getItem("buildingId")
let buildingName = sessionStorage.getItem("buildingName")
let floor = sessionStorage.getItem("floor")
let floorId = sessionStorage.getItem("floorId")
let floorName = sessionStorage.getItem("floorName")
const mobileWidth = 768



const initialState = {
    sample_id: "",
    organism: "",
    location: "",
    date_time: new Date(),
    comments: "",
    typeofSamples: "",
    typeofAnalysis: "",
    isDeleteModalOpen: false,
    isMultiDeleteModalOpen: false,
    isEditBarcodeModelOpen: false,
    isOtherResultModalOpen: false,
    isConfirmResultModalOpen: false,
    deleteSampleID: "",
    deleteID: "",
    fileName: "",
    pictureFile: "",
    picturefileName: "",
    building: building ? building : localStorage.getItem("guest") ? "BldgA" : "",
    floor: floor ? floor : localStorage.getItem("guest") ? 20000 : "",
    floorId: floorId ? floorId : localStorage.getItem("guest") ? 20000 : "",
    buildingId: buildingId ? buildingId : localStorage.getItem("guest") ? 20000 : "",
    buildingName: buildingName ? buildingName : localStorage.getItem("guest") ? "Building A" : "",
    floorName: floorName ? floorName : localStorage.getItem("guest") ? "Floor A" : "",
    batchNumber: "",
    barcode: "",
    isDisable: false,
    edit: false,
    isEditModalOpen: false,
    searchSample: "",
    referenceGenome: "",
    view: true,
    isUploadModalOpen: false,
    type: "direct",
    checked: [],
    microbiomeOrganisms: [{ name: '', percentage: '' }],
    selectedCriterion: null,
    numericResult: '',
}
// const ExcelFile = ExcelFile;
// const ExcelSheet = ExcelFile.ExcelSheet;
// const ExcelColumn = ExcelFile.ExcelColumn;
let errorDetails = ""
let editSampleId = ""
const sampleScanRef = React.createRef();
const barCodeScanRef = React.createRef();


class Sample extends React.Component {
    constructor(props) {
        super(props)
        this.saveData = this.saveData.bind(this)
        this.resetData = this.resetData.bind(this)
        this.validateData = this.validateData.bind(this)
        this.ErrorDetails = this.ErrorDetails.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.onChange = this.onChange.bind(this)
        this.deleteSample = this.deleteSample.bind(this)
        this.deleteMultipleSamples = this.deleteMultipleSamples.bind(this)
        this.onSelectTestType = this.onSelectTestType.bind(this)
        this.toggle = this.toggle.bind(this);
        this.routeChange = this.routeChange.bind(this);
        this.setResults = this.setResults.bind(this);

        building = sessionStorage.getItem("building")
        buildingId = sessionStorage.getItem("buildingId")
        buildingName = sessionStorage.getItem("buildingName")
        floor = sessionStorage.getItem("floor")
        floorId = sessionStorage.getItem("floorId")
        floorName = sessionStorage.getItem("floorName")
        let floorInitialState = {
            building: building ? building : localStorage.getItem("guest") ? "BldgA" : "",
            floor: floor ? floor : localStorage.getItem("guest") ? 20000 : "",
            floorId: floorId ? floorId : localStorage.getItem("guest") ? 20000 : "",
            buildingId: buildingId ? buildingId : localStorage.getItem("guest") ? 20000 : "",
            buildingName: buildingName ? buildingName : localStorage.getItem("guest") ? "Building A" : "",
            floorName: floorName ? floorName : localStorage.getItem("guest") ? "Floor A" : "",
        }


        this.state = {
            ...initialState,
            ...floorInitialState,
            windowWidth: window.innerWidth,
            fileName: "Samples_" + moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
            isBarcodeScan: false,
            isLocationScan: false,
            isFilterEnabled: false,
            filtered: [],
            filterLocation_id: [],
            filterStatus: [],
            filterOrganism: [],
            filterType_of_samples: [],
            filterType_of_analysis: [],
            filterReference_genome: [],
            filterCount: 0,
            loaderSamples: true,
            otherResult: null,
            acceptanceCriteria: [],
        }
    }

    filterRenderer = ({ filter, onChange }) =>
        <input
            className='placeholder-icon-input'
            type='text'
            placeholder='Search'
            value={filter ? filter.value : ''}
            onChange={(event) => onChange(event.target.value)}
        />

    columns = [
        {
            Header: state => (
                <CustomInput type="checkbox"
                    className="custom-selectall-checkbox"
                    id="select-all-samples"
                    checked={this.props.downloadsamples.length === this.state.checked.length}
                    intermediate={this.state.checked.length !== 0 && this.props.downloadsamples.length > this.state.checked.length}
                    onClick={() => this.selectAll()} />
            ),
            id: 'checkbox',
            accessor: str => "checkbox",
            Cell: (row) => {
                let checked = this.state.checked.includes(row.index)
                return <CustomInput type="checkbox" className={checked ? "custom-table-checkbox select-checked" : "custom-table-checkbox"} id={row.original.id} checked={checked} onClick={() => this.handleCheckClick(row.index)} />
            },
            width: 50,
            Filter: () => <div clasName="checkbox-sticky-style"></div>,
            filterable: false,
            headerClassName: 'checkbox-sticky-style',
            className: 'checkbox-sticky-style'
        },
        {
            Header: 'Sample ID',
            accessor: 'sample_id',
            Cell: (row) => {
                if (row.original.parent !== null && row.original.parent !== undefined) {
                    return <>{row.original.sample_id + " "}<FontAwesomeIcon className="sample-parent" title={"Child sample of " + row.original.parent.sample_id} icon={faArrowsAltV} size="lg" ></FontAwesomeIcon></>
                }
                else {
                    return <>{row.original.sample_id}</>
                }
            },
            Filter: this.filterRenderer,
            width: 120
        },
        {
            accessor: 'id',
            headerClassName: "not-visible",
            className: "not-visible",
            width: 0
        },
        {
            Header: '',
            accessor: 'result',
            Cell: (row) => {
                if (!row.original.is_result_generated) {
                    return <span onClick={() => this.openOtherResult(row)} className="cursor-change-plus">
                        <abbr title="Add Result">
                            +
                        </abbr>
                    </span>
                }
                else {
                    return null
                }
            },
            width: 40,
        },
        {
            Header: "Status",
            id: 'is_result_generated',
            accessor: "is_result_generated",
            Cell: (row) => {
                if (row.original.is_result_generated) {
                    return <div className='result-arrived'>Result Arrived</div>
                }
                else {
                    return <div className='waiting'>Waiting</div>
                }
            },
            Filter: ({ filter, onChange }) => {
                return this.customFilter({ field: "is_result_generated", filter, onChange })
            },
            width: 120,
        },
        {
            Header: () => <><span id="EFBarcode">EF Barcode</span>
                <CustomToolTip placement="top" target="EFBarcode" hide={false} text="Eurofins generated barcode" /></>,
            accessor: 'barcode',
            Filter: this.filterRenderer,
            width: 160
        },
        {
            Header: 'Batch Number',
            accessor: 'batch_no',
            Filter: this.filterRenderer,
            width: 120
        },
        {
            Header: 'Location ID',
            id: 'location_id',
            accessor: "location.location_id",
            Cell: (row) => {
                if (row.original.unit) {
                    return <div>{(row.original.location.location_id || row.original.location) + ', ' + (row.original.unit.unit_id || row.original.unit)}</div>
                }
                else {
                    return <div>{row.original.location.location_id || row.original.location}</div>
                }
            },
            Filter: ({ filter, onChange }) => {
                return this.customFilter({ field: "location_id", filter, onChange })
            },
            width: 180
        },
        {
            Header: 'Date & Time',
            accessor: 'date_time',
            Cell: (props) => {
                let date = new Date(props.value)
                date = moment(date).format('MMM D, YYYY HH:mm')
                return <span>{date}</span>
            },
            width: 180,
            filterable: false
        },
        {
            Header: 'Organism',
            accessor: 'organism',
            Filter: ({ filter, onChange }) => {
                return this.customFilter({ field: "organism", filter, onChange })
            },
            width: 120
        },
        {
            Header: 'Type of Sample',
            Filter: ({ filter, onChange }) => {
                return this.customFilter({ field: "type_of_samples", filter, onChange })
            },
            accessor: 'type_of_samples',
            width: 120
        },
        {
            Header: 'Type of Analysis',
            Filter: ({ filter, onChange }) => {
                return this.customFilter({ field: "type_of_analysis", filter, onChange })
            },
            accessor: 'type_of_analysis',
            width: 120
        },
        {
            Header: 'Reference Genome',
            accessor: 'reference_genome',
            Filter: ({ filter, onChange }) => {
                return this.customFilter({ field: "reference_genome", filter, onChange })
            },
            width: 150,
        },
        {
            Header: 'Comments',
            accessor: 'comments',
            Filter: this.filterRenderer,
            width: 150,
        },
        {
            Header: 'Image',
            accessor: 'picture',
            Cell: (row) => (
                <div><a href="#samples" title={this.pictureData(row.original.picture)} onClick={() => {
                    if (row.original.picture) {
                        var image = new Image()
                        image.src = row.original.picture[1]
                        var win = window.open("");
                        win.document.write(image.outerHTML);
                    }
                }}>{this.pictureData(row.original.picture) != "" ? this.pictureData(row.original.picture).slice(0, 20) + '...' : this.pictureData(row.original.picture)}</a></div>
            ),
            minWidth: 200,
            maxWidth: 400,
            filterable: false
        },
    ]
    openOtherResult = (row) => {
        this.setState({
            isOtherResultModalOpen: !this.state.isOtherResultModalOpen,
            rowBarcode: row.original.barcode,
            rowDateTime: moment(row.original.date_time).format('MMMM D, YYYY HH:mm'),
            rowTypeOfSample: row.original.type_of_samples,
            rowTypeOrganism: row.original.organism,
            rowSampleID: row.original,
        })
    }
    toggle() {
        const filtered = this.state.filtered
        this.setState({
            isFilterEnabled: !this.state.isFilterEnabled,
            filtered: filtered,
        });
    }

    handleButtonClick = (e, row) => {
        this.setState(prevState => ({
            isDeleteModalOpen: !prevState.isDeleteModalOpen,
            deleteSampleID: row.sample_id ? row.sample_id : row.original.sample_id ? row.original.sample_id : "",
            deleteID: row.id ? row.id : row.original.id ? row.original.id : ""
        }));
    }

    handleEditBarcode = () => {
        let message = ''
        if (this.state.currentStatus && this.state.edittypeofAnalysis !== this.state.currentTypeofAnalysis && this.state.editbarcode !== this.state.currentBarcode && this.state.count === 0) {
            message = <div>You are creating a new child sample, are you sure you want to proceed?</div>
        }
        else if (this.state.currentStatus && this.state.edittypeofAnalysis !== this.state.currentTypeofAnalysis && this.state.count === 0) {
            message = <div>You are creating a new child sample, please recheck for EF Barcode value.</div>
        }
        else if (this.state.editbarcode !== this.state.currentBarcode) {
            message = <div>EF Barcode is changed from <i>{this.state.currentBarcode}</i> to <i>{this.state.editbarcode}</i>. Are you sure you want to proceed?</div>
        }
        message ? this.setState(prevState => ({
            isEditBarcodeModelOpen: true,
            warningMessage: message
        })) : this.saveData()
    }

    componentDidMount() {
        this.props.fetchSamplesList({ page_size: 1 })
        if (sessionStorage.getItem("building"))
            this.onSelectBuilding("", true)
        let persist_root = localStorage.getItem('persist:root')
        var root = JSON.parse(persist_root);
        var sample_data = JSON.parse(root.sample_data)
        this.props.downloadSampleData(this.props.sampleSearch ? { search: this.props.sampleSearch } : null).then(
            response => {
                this.setState({ loaderSamples: false })
            }
        )
        if (sample_data.downloadSampleData === undefined || sample_data.downloadSampleData.length === 0) {
            this.setState({ loaderSamples: true })
        }
        else {
            this.setState({ loaderSamples: false })
        }
        this.props.fetchAcceptanceCriteria().then(res => {
            if (res && res.data) this.setState({ acceptanceCriteria: res.data })
        }).catch(() => { })
        window.addEventListener('resize', this.handleWindowResize);
    }


    componentWillUnmount() {
        this.props.setSearch('');
        window.removeEventListener('resize', this.handleWindowResize);
    }

    handleWindowResize = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    onSelectBuilding = (event, flag = false) => {
        if (flag === false) {
            const { value, selectedOptions } = event.target
            sessionStorage.setItem("building", value)
            sessionStorage.setItem("buildingId", selectedOptions[0].id)
            sessionStorage.setItem("buildingName", selectedOptions[0].innerText)
            sessionStorage.setItem("floor", "")
        }
        this.setState({
            ...this.state,
            building: sessionStorage.getItem("building"),
            buildingId: sessionStorage.getItem("buildingId"),
            buildingName: sessionStorage.getItem("buildingName"),
            floor: "",
        }, async () => {
            await this.props.fetchFloors(this.state.buildingId)
            if (sessionStorage.getItem("floor"))
                await this.onSelectFloor("", true)
        })
    }

    onSelectFloor = (event, flag = false) => {
        if (flag === false) {
            const { value, selectedOptions } = event.target
            sessionStorage.setItem("floorName", selectedOptions[0].innerText)
            sessionStorage.setItem("floorId", selectedOptions[0].id)
            sessionStorage.setItem("floor", value)
        }
        this.setState({
            ...this.state,
            floor: sessionStorage.getItem("floor"),
            floorId: sessionStorage.getItem("floorId"),
            floorName: sessionStorage.getItem("floorName"),
        }, () => {
            this.props.fetchLocationList({
                floor__id: this.state.floorId,
                floor__building_id: this.state.buildingId
            })
        })
    }

    handleChangeBuliding = (event) => {
        this.setState({ editbuilding: event.target.value, editfloor: "", editlocation: "" }, async () => {
            await this.props.fetchFloors(this.state.editbuilding)
        })
    }

    handleChangeFloor = (event) => {
        this.setState({ editfloor: event.target.value, editlocation: "" }, () => {
            this.props.fetchLocationList({
                floor__id: this.state.editfloor,
                floor__building_id: this.state.editbuilding
            })
        })
    }

    pictureData = (data) => {
        var fileName = ""
        if (data != null) {
            fileName = data[0]
        }
        return fileName
    }



    deleteSample = () => {
        this.props.deleteSample(this.state.deleteID).then(response => {
            if (response.status === 204) {
                let message = "Sample List Deleted Successfully!"
                appInsights.trackEvent({ name: 'Sample Deleted', properties: { id: this.state.deleteID } });
                appInsights.trackTrace({ message: message, properties: { id: this.state.deleteID }, severityLevel: SeverityLevel.Information })
                toast.success(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
            else {
                let message = "Sample List couldn't be deleted!"
                appInsights.trackTrace({ message: message, properties: { id: this.state.deleteID }, severityLevel: SeverityLevel.Error });
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
            this.resetData()
        })
            .catch(() => {
                let message = "Sample List couldn't be deleted!"
                appInsights.trackTrace({ message: message, properties: { id: this.state.deleteID }, severityLevel: SeverityLevel.Error });
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                this.resetData()
            })
    }

    deleteMultipleSamples = () => {
        const filtered = this.state.filtered
        const filterCount = this.state.filterCount
        const filterStatus = this.state.filterStatus
        const filterLocation_id = this.state.filterLocation_id
        const filterOrganism = this.state.filterOrganism
        const filterType_of_samples = this.state.filterType_of_samples
        const filterType_of_analysis = this.state.filterType_of_analysis
        const filterReference_genome = this.state.filterReference_genome
        const isFilterEnabled = this.state.isFilterEnabled

        let ids = this.state.checked.map((data) => this.props.downloadsamples[data].id)
        this.props.deleteMultipleSamples(ids).then(response => {
            if (response.status === 204) {
                let message = "Samples Deleted Successfully!"
                appInsights.trackEvent({ name: 'Samples Deleted', properties: { id: ids } });
                appInsights.trackTrace({ message: message, properties: { id: ids }, severityLevel: SeverityLevel.Information })
                toast.success(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                this.setState({
                    isFilterEnabled: isFilterEnabled,
                    filtered: filtered,
                    filterCount: filterCount,
                    filterStatus: filterStatus,
                    filterLocation_id: filterLocation_id,
                    filterOrganism: filterOrganism,
                    filterType_of_samples: filterType_of_samples,
                    filterType_of_analysis: filterType_of_analysis,
                    filterReference_genome: filterReference_genome

                })
            }
            else {
                let message = "Samples couldn't be deleted!"
                appInsights.trackTrace({ message: message, properties: { id: ids }, severityLevel: SeverityLevel.Error });
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                this.setState({
                    isFilterEnabled: isFilterEnabled,
                    filtered: filtered,
                    filterCount: filterCount,
                    filterStatus: filterStatus,
                    filterLocation_id: filterLocation_id,
                    filterOrganism: filterOrganism,
                    filterType_of_samples: filterType_of_samples,
                    filterType_of_analysis: filterType_of_analysis,
                    filterReference_genome: filterReference_genome
                })
            }
            this.resetData()
        })
            .catch(() => {
                let message = "Sample List couldn't be deleted!"
                appInsights.trackTrace({ message: message, properties: { id: ids }, severityLevel: SeverityLevel.Error });
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                this.resetData()
            })
    }

    toggleDeleteModal = () => {
        this.setState(prevState => ({
            isDeleteModalOpen: !prevState.isDeleteModalOpen,
            deleteLocationId: ""
        }));
    }

    toggleMultiDeleteModal = () => {
        this.setState(prevState => ({
            isMultiDeleteModalOpen: !prevState.isMultiDeleteModalOpen,
        }));
    }
    toggleEditModal = (data) => {
        this.setState(prevState => ({
            isEditModalOpen: !prevState.isEditModalOpen,
        }))
        return data.sample_id ? this.modifySample(data) : null
    }

    toggleEditBarcodeModal = () => {
        this.setState(prevState => ({
            isEditBarcodeModelOpen: false,
            warningMessage: ''
        }))
    }
    toggleOtherResult = () => {
        this.setState(prevState => ({
            isOtherResultModalOpen: !prevState.isOtherResultModalOpen,
            otherResult: null,
            selectedCriterion: null,
            numericResult: '',
            microbiomeOrganisms: [{ name: '', percentage: '' }]
        }))
    }
    toggleOtherResultSave = () => {
        if (this.isResultValid()) {
            this.setState(prevState => ({
                isOtherResultModalOpen: false,
                isConfirmResultModalOpen: true,
            }));
        }
    }
    toggleOtherResultNo = () => {
        this.setState(prevState => ({
            isOtherResultModalOpen: !prevState.isOtherResultModalOpen,
            isConfirmResultModalOpen: !this.state.isConfirmResultModalOpen,
            otherResult: null
        }))
    }
    onChange = date => {
        return this.setState({ date_time: date })
    };

    onChangeDate = date => {
        return this.setState({ editdate_time: date })
    }

    handleChange(event) {
        const name = event.target.name;
        const value = event.target.value;
        const newAnalysisTypes = [
            'Salmonella spp', 'Listeria monocytogenes', 'Listeria spp',
            'Contagem Total de Mesófilos', 'Bolores e Leveduras',
            'Estafilococos coagulase Positiva', 'Bacillus cereus',
            'Coliformes Totais', 'Escherichia coli', 'Enterobacterias'
        ];
        if (name === 'typeofAnalysis' && newAnalysisTypes.includes(value)) {
            this.setState({ ...this.state, [name]: value, organism: value });
        } else {
            this.setState({ ...this.state, [name]: value });
        }
    };
    handleOther(event) {
        this.setState({
            ...this.state,
            otherResult: event.target.value,
        })
    }
    criterionLabel = (c) => {
        const prog = c.program?.name || '';
        const tipo = c.sample_type ? ` — ${c.sample_type}` : '';
        return `${prog}${tipo}`;
    }

    criterionRule = (c) => {
        if (!c) return '';
        const unit = c.unit?.code ? ` ${c.unit.code}` : '';
        if (c.operator === 'absence') return 'Espera-se Ausência';
        if (c.operator === 'presence') return 'Espera-se Presença';
        const op = c.operator === 'lte' ? '≤' : '<';
        return `Limite: ${op} ${c.limit_value}${unit}`;
    }

    // veredito provisório, só para feedback imediato na tela
    previewVerdict = () => {
        const c = this.state.selectedCriterion;
        if (!c) return null;
        if (c.operator === 'absence' || c.operator === 'presence') {
            if (!this.state.otherResult) return null;
            const isAbsent = this.state.otherResult === 'Ausência';
            const ok = c.operator === 'absence' ? isAbsent : !isAbsent;
            return ok ? 'Aprovado' : 'Reprovado';
        }
        if (this.state.numericResult === '') return null;
        const v = parseFloat(this.state.numericResult);
        if (isNaN(v)) return null;
        const ok = c.operator === 'lte' ? v <= c.limit_value : v < c.limit_value;
        return ok ? 'Aprovado' : 'Reprovado';
    }

    isResultValid = () => {
        const c = this.state.selectedCriterion;
        if (this.state.rowSampleID?.type_of_analysis === 'Microbiome') {
            return this.state.microbiomeOrganisms.some(o => o.name.trim() && o.percentage !== '');
        }
        if (c && c.operator !== 'absence' && c.operator !== 'presence') {
            return this.state.numericResult !== '' && !isNaN(parseFloat(this.state.numericResult));
        }
        return !!this.state.otherResult;
    }
    handleCheckClick = (value) => {
        this.setState(prevState => ({
            checked: prevState.checked.includes(value) ? [...prevState.checked.filter((val) => val !== value)] : [...prevState.checked, value],
        }))
    }

    selectAll = () => {
        this.setState({
            checked: this.state.checked.length < this.props.downloadsamples.length ? [...Array(this.props.downloadsamples.length).keys()] : []
        })
    }

    routeChange = () => {
        let path = '/offlinePage';
        this.props.history.push(path);
    }
    saveData = () => {
        const filtered = this.state.filtered
        const filterCount = this.state.filterCount
        const filterStatus = this.state.filterStatus
        const filterLocation_id = this.state.filterLocation_id
        const filterOrganism = this.state.filterOrganism
        const filterType_of_samples = this.state.filterType_of_samples
        const filterType_of_analysis = this.state.filterType_of_analysis
        const filterReference_genome = this.state.filterReference_genome
        const isFilterEnabled = this.state.isFilterEnabled
        if (this.validateData(this.state)) {
            let split_data = this.state.edit ? this.state.editlocation.split(',') : this.state.location.split(',')
            let location = split_data[0]
            let unit = ""
            if (split_data.length === 2) {
                unit = split_data[1]
            }
            let organism = this.state.organism ? this.state.organism[0].toUpperCase() + this.state.organism.substr(1, this.state.organism.length).toLowerCase() : ""
            if (this.state.edit) {
                if (editSampleId === this.state.sample_id) {
                    editSampleId = ""
                    this.setState({
                        isDisable: false,
                        edit: false
                    })
                    organism = this.state.editOrganism ? this.state.editOrganism[0].toUpperCase() + this.state.editOrganism.substr(1, this.state.editOrganism.length).toLowerCase() : ""
                    if (this.state.currentStatus && this.state.edittypeofAnalysis !== this.state.currentTypeofAnalysis && this.state.count === 0) {
                        //need to find the status and parentId from the sample and pass it here
                        let createData = {
                            parent: this.state.currentParent,
                            organism: organism,
                            location: location,
                            unit: unit,
                            date_time: this.state.editdate_time,
                            comments: this.state.editComments,
                            type_of_analysis: this.state.edittypeofAnalysis,
                            type_of_samples: this.state.edittypeofSamples,
                            batch_no: this.state.editbatchNumber,
                            barcode: this.state.editbarcode,
                            reference_genome: this.state.edittypeofAnalysis === "SNP" ? this.state.editreferenceGenome : ""
                        }
                        if (this.state.editpictureFile != null) {
                            if (this.state.editpictureFile.type.split("/")[0] === "image") {
                                createData.picture = this.state.editpictureFile
                            }
                        }
                        this.props.saveSample(
                            createData
                        ).then(response => {
                            if (response.status === 201) {
                                let message = "Sample data added successfully to the list"
                                appInsights.trackEvent({ name: 'Child Sample Created', properties: { id: response.data.barcode } });
                                appInsights.trackTrace({ message: 'Child Sample Created', properties: { id: response.data.barcode, type: 'child' }, severityLevel: SeverityLevel.Information })
                                toast.success(message, {
                                    position: toast.POSITION.BOTTOM_RIGHT
                                });
                            }
                            else if (!navigator.onLine) {
                                let message = "Sample List added in offline mode!"
                                appInsights.trackTrace({ message: message, properties: { id: this.state.editbarcode, type: 'child' }, severityLevel: SeverityLevel.Information })
                                toast.warn(message, {
                                    position: toast.POSITION.BOTTOM_RIGHT
                                });
                            }
                            else {
                                let message = "Sample List couldn't be added!"
                                appInsights.trackTrace({ message: message, properties: { id: this.state.editbarcode, type: 'child' }, severityLevel: SeverityLevel.Error })
                                toast.error(message, {
                                    position: toast.POSITION.BOTTOM_RIGHT
                                });
                            }
                            this.resetData()
                        })
                            .catch((error) => {
                                let errors = (error.response && error.response.data) || ""
                                if (errors && errors.barcode) {
                                    let message = "Sample with this EF Barcode already exists !"
                                    appInsights.trackTrace({ message: message, properties: { id: this.state.editbarcode, type: 'child', error: error }, severityLevel: SeverityLevel.Error })
                                    toast.error(message, {
                                        position: toast.POSITION.BOTTOM_RIGHT
                                    })
                                }
                                else if (!navigator.onLine) {
                                    let message = "Sample List added in offline mode!"
                                    appInsights.trackTrace({ message: message, properties: { id: this.state.editbarcode, error: error }, severityLevel: SeverityLevel.Information })
                                    toast.warn(message, {
                                        position: toast.POSITION.BOTTOM_RIGHT
                                    });
                                }
                                else {
                                    let message = "Sample couldn't be added !"
                                    appInsights.trackTrace({ message: message, properties: { id: this.state.editbarcode, type: 'child', error: error }, severityLevel: SeverityLevel.Error })
                                    toast.error(message, {
                                        position: toast.POSITION.BOTTOM_RIGHT
                                    })
                                }
                                this.resetData()
                            })
                    }
                    else {
                        var data = {
                            id: this.state.id,
                            sample_id: this.state.sample_id,
                            organism: organism,
                            location: location,
                            unit: unit,
                            date_time: this.state.editdate_time,
                            comments: this.state.editComments,
                            is_result_generated: this.state.currentStatus,
                            type_of_analysis: this.state.edittypeofAnalysis,
                            type_of_samples: this.state.edittypeofSamples,
                            batch_no: this.state.editbatchNumber,
                            barcode: this.state.editbarcode,
                            reference_genome: this.state.edittypeofAnalysis === "SNP" ? this.state.editreferenceGenome : ""
                        }
                        if (this.state.editpictureFile != null) {
                            if (this.state.editpictureFile.type.split("/")[0] === "image") {
                                data.picture = this.state.editpictureFile
                            }
                        }
                        this.props.updateSample({
                            data
                        }).then(response => {
                            if (response.status === 200) {
                                let message = "Sample List Updated Successfully!"
                                appInsights.trackEvent({ name: 'Sample Updated', properties: { id: response.data.barcode } });
                                appInsights.trackTrace({ message: message, properties: { id: response.data.barcode }, severityLevel: SeverityLevel.Information })
                                toast.success(message, {
                                    position: toast.POSITION.BOTTOM_RIGHT
                                });
                                this.setState({
                                    isFilterEnabled: isFilterEnabled,
                                    filtered: filtered,
                                    filterCount: filterCount,
                                    filterStatus: filterStatus,
                                    filterLocation_id: filterLocation_id,
                                    filterOrganism: filterOrganism,
                                    filterType_of_samples: filterType_of_samples,
                                    filterType_of_analysis: filterType_of_analysis,
                                    filterReference_genome: filterReference_genome
                                })
                            }
                            else {
                                let message = "Sample List couldn't be updated!"
                                appInsights.trackTrace({ message: message, properties: { id: this.state.editbarcode }, severityLevel: SeverityLevel.Error })
                                toast.error(message, {
                                    position: toast.POSITION.BOTTOM_RIGHT
                                });
                                this.setState({
                                    isFilterEnabled: isFilterEnabled,
                                    filtered: filtered,
                                    filterCount: filterCount,
                                    filterStatus: filterStatus,
                                    filterLocation_id: filterLocation_id,
                                    filterOrganism: filterOrganism,
                                    filterType_of_samples: filterType_of_samples,
                                    filterType_of_analysis: filterType_of_analysis,
                                    filterReference_genome: filterReference_genome
                                })
                            }
                            this.resetData()
                        })
                            .catch((error) => {
                                let message = "Sample couldn't be updated!"
                                appInsights.trackTrace({ message: message, properties: { id: this.state.editbarcode, error: error }, severityLevel: SeverityLevel.Error })
                                toast.error(message, {
                                    position: toast.POSITION.BOTTOM_RIGHT
                                })
                                this.setState({
                                    isFilterEnabled: isFilterEnabled,
                                    filtered: filtered,
                                    filterCount: filterCount,
                                    filterStatus: filterStatus,
                                    filterLocation_id: filterLocation_id,
                                    filterOrganism: filterOrganism,
                                    filterType_of_samples: filterType_of_samples,
                                    filterType_of_analysis: filterType_of_analysis,
                                    filterReference_genome: filterReference_genome
                                })
                                this.resetData()
                            })
                    }
                }
                else {
                    this.setState({
                        isFilterEnabled: isFilterEnabled,
                        filtered: filtered,
                        filterCount: filterCount,
                        filterStatus: filterStatus,
                        filterLocation_id: filterLocation_id,
                        filterOrganism: filterOrganism,
                        filterType_of_samples: filterType_of_samples,
                        filterType_of_analysis: filterType_of_analysis,
                        filterReference_genome: filterReference_genome
                    })
                    let message = "Sample ID can't be updated while editing!"
                    appInsights.trackTrace({ message: message, severityLevel: SeverityLevel.Verbose })
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            }
            else {
                this.props.saveSample({
                    organism: organism,
                    location: location,
                    unit: unit,
                    date_time: this.state.date_time,
                    comments: this.state.comments,
                    type_of_analysis: this.state.typeofAnalysis,
                    type_of_samples: this.state.typeofSamples,
                    picture: this.state.pictureFile,
                    batch_no: this.state.batchNumber,
                    barcode: this.state.barcode,
                    reference_genome: this.state.typeofAnalysis === "SNP" ? this.state.referenceGenome : ""
                }).then(response => {
                    if (response.status === 201) {
                        let message = "Sample data added successfully to the list"
                        appInsights.trackEvent({ name: 'Sample Created', properties: { id: response.data.barcode } });
                        appInsights.trackTrace({ message: 'Sample Created', properties: { id: response.data.barcode }, severityLevel: SeverityLevel.Information })
                        toast.success(message, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                        this.props.fetchSamplesList({ page_size: 1 })
                        this.props.downloadSampleData()

                    }
                    else if (!navigator.onLine) {
                        let message = "Sample List added in offline mode!"
                        appInsights.trackTrace({ message: message, properties: { id: this.state.barcode }, severityLevel: SeverityLevel.Information })
                        toast.warn(message, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }
                    else {
                        let message = "Sample List couldn't be added!"
                        appInsights.trackTrace({ message: message, properties: { id: this.state.barcode }, severityLevel: SeverityLevel.Error })
                        toast.error(message, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }
                })
                    .catch((error) => {
                        let errors = (error.response && error.response.data) || ""
                        if (errors && errors.barcode) {
                            let message = "Sample with this EF Barcode already exists !"
                            appInsights.trackTrace({ message: message, properties: { id: this.state.barcode, error: error }, severityLevel: SeverityLevel.Error })
                            toast.error(message, {
                                position: toast.POSITION.BOTTOM_RIGHT
                            })
                        }
                        else if (!navigator.onLine) {
                            let message = "Sample List added in offline mode!"
                            appInsights.trackTrace({ message: message, properties: { id: this.state.barcode }, severityLevel: SeverityLevel.Information })
                            toast.warn(message, {
                                position: toast.POSITION.BOTTOM_RIGHT
                            });
                        }
                        else {
                            let message = "Sample couldn't be added !"
                            appInsights.trackTrace({ message: message, properties: { id: this.state.barcode, error: error }, severityLevel: SeverityLevel.Error })
                            toast.error(message, {
                                position: toast.POSITION.BOTTOM_RIGHT
                            })
                        }
                    })
                this.setState({
                    organism: "",
                    location: "",
                    date_time: new Date(),
                    comments: "",
                    typeofSamples: "",
                    typeofAnalysis: "",
                    isDeleteModalOpen: false,
                    isMultiDeleteModalOpen: false,
                    isEditBarcodeModelOpen: false,
                    deleteSampleID: "",
                    deleteID: "",
                    fileName: "",
                    pictureFile: "",
                    picturefileName: "",
                    batchNumber: "",
                    barcode: "",
                    referenceGenome: ""
                })
            }
        }
        else {
            this.ErrorDetails()
        }
    }

    ErrorDetails = () => {
        appInsights.trackTrace({ message: errorDetails, properties: { page: "sample" }, severityLevel: SeverityLevel.Verbose })
        toast.error(errorDetails, {
            position: toast.POSITION.BOTTOM_RIGHT
        })
        errorDetails = ""
        return true
    }

    resetData = () => {
        this.setState({
            ...initialState,
            view: true
        }, () => {
            this.props.fetchFloors(this.state.buildingId)
            this.props.fetchLocationList()
        })
        this.props.fetchSamplesList({ page_size: 1 })
        this.props.downloadSampleData()
    }

    cancelData = () => {
        this.setState(initialState)
    }

    searchSample = () => {
        this.setState({
            ...this.state,
            view: false
        })
        this.props.downloadSampleData({ search: this.state.searchSample })
    }

    validateData = (data) => {
        let isValidDate = moment(data.date_time).isValid()
        let isvalidEditDate = moment(data.editdate_time).isValid()
        if (data.edit) {
            if ((data.barcode.trim().length === 0 && isValidDate && data.location.length === 0 && data.organism.trim().length === 0 && data.referenceGenome.trim().length === 0) && (data.edit && data.editbarcode.trim().length === 0 && isvalidEditDate && data.editlocation.length === 0 && data.editOrganism.trim().length === 0 && data.editreferenceGenome.trim().length === 0)) {
                errorDetails = "All *mandatory fields are required to save Sample data"
                return false
            }
        }
        else {
            if ((data.barcode.trim().length === 0 && isValidDate && data.location.length === 0 && data.organism.trim().length === 0 && data.referenceGenome.trim().length === 0) || (data.edit && data.editbarcode.trim().length === 0 && isvalidEditDate && data.editlocation.length === 0 && data.editOrganism.trim().length === 0 && data.editreferenceGenome.trim().length === 0)) {
                errorDetails = "All *mandatory fields are required to save Sample data"
                return false
            }
        }
        if ((data.barcode.trim().length > 0 && isValidDate && data.location.length > 0 && ((data.typeofAnalysis === "Microbiome" && (data.organism.trim().length > 0 || data.organism.trim().length === 0)) || (data.organism.trim().length > 0)) && ((data.typeofAnalysis === "SNP" && data.referenceGenome.trim().length > 0) || (data.typeofAnalysis !== "SNP"))) || (data.edit && data.editbarcode.trim().length > 0 && isvalidEditDate && data.editlocation.length > 0 && data.editOrganism.trim().length > 0 && ((data.edittypeofAnalysis === 'SNP' && data.editreferenceGenome.trim().length > 0) || (data.edittypeofAnalysis !== 'SNP')))) {
            return true
        }
        else if ((data.barcode.trim().length > 0 && isValidDate && data.location.length > 0 && data.organism.trim().length > 0 && data.typeofAnalysis === "SNP" && data.referenceGenome.trim().length === 0) || (data.edit && data.editbarcode.trim().length > 0 && isvalidEditDate && data.editlocation.length > 0 && data.editOrganism.trim().length > 0 && data.edittypeofAnalysis === 'SNP' && data.editreferenceGenome.trim().length === 0)) {
            errorDetails = "Reference Genome is empty"
            return false
        }
        else if ((data.barcode.trim().length > 0 && isValidDate && data.organism.trim().length > 0 && data.referenceGenome.trim().length > 0 && data.location.length === 0) || (data.edit && data.editbarcode.trim().length > 0 && isvalidEditDate && data.editOrganism.trim().length > 0 && data.editreferenceGenome.trim().length > 0 && data.editlocation.length === 0)) {
            errorDetails = "Select the Location from the dropdown"
            return false
        }
        else if ((isValidDate && data.organism.trim().length > 0 && data.referenceGenome.trim().length > 0 && data.location.length > 0 && data.barcode.trim().length === 0) || (data.edit && isvalidEditDate && data.editOrganism.trim().length > 0 && data.editreferenceGenome.trim().length > 0 && data.editlocation.length > 0 && data.editbarcode.trim().length === 0)) {
            errorDetails = "EF Barcode value is empty"
            return false
        }
        else if ((data.barcode.trim().length > 0 && isValidDate && data.referenceGenome.trim().length > 0 && data.location.length > 0 && data.organism.trim().length === 0) || (data.edit && isvalidEditDate && data.editreferenceGenome.trim().length > 0 && data.editlocation.length > 0 && data.editbarcode.trim().length > 0 && data.editOrganism.trim().length === 0)) {
            errorDetails = "Organism value is empty"
            return false
        }
        else if ((data.barcode.trim().length > 0 && data.referenceGenome.trim().length > 0 && data.location.length > 0 && data.organism.trim().length > 0 && !isValidDate) || (data.edit && data.editreferenceGenome.trim().length > 0 && data.editlocation.length > 0 && data.editbarcode.trim().length > 0 && data.editOrganism.trim().length > 0 && !isvalidEditDate)) {
            errorDetails = "Date entered is not valid"
            return false
        }
        else {
            errorDetails = "All *mandatory fields are required to save Sample data"
            return false
        }

    }

    handleFileChange({ target: { files } }) {
        if (files.length !== 0) {
            this.setState({
                picturefileName: files[0].name,
                pictureFile: files[0]
            })
        }
    }

    handleEditFileChange({ target: { files } }) {
        if (files.length !== 0) {
            this.setState({
                editfileName: files[0].name,
                editpictureFile: files[0]
            })
        }
    }

    onSelectTestType = (event) => {
        let organism = this.state.organism
        if (event.currentTarget.value === "Classical Testing") {
            organism = ""
        }
        this.setState({
            typeofTesting: event.currentTarget.value,
            organism: organism
        })
    }

    modifySample = (data) => {
        let date = new Date(data.date_time)
        editSampleId = data.sample_id
        let unit
        if (data.unit) {
            unit = data.unit.id
        }
        let building = data.location.floor.building.id
        let floor = data.location.floor.id
        let building_filter = this.props.buildingList.filter(val => val.id === parseInt(building))
        let floor_filter = building_filter[0].floors.filter(val => val.id === parseInt(floor))[0]
        this.props.fetchFloors(floor_filter.building)

        this.props.fetchLocationList({
            floor__id: floor_filter.id,
            floor__building_id: floor_filter.building
        })
        this.setState({
            "count": data.count,
            "currentStatus": data.is_result_generated,
            "currentParent": data.id,
            "currentTypeofAnalysis": data.type_of_analysis,
            "currentBarcode": data.barcode,
            "id": data.id,
            "sample_id": data.sample_id,
            "editOrganism": data.organism,
            "editbuilding": building,
            "editfloor": floor,
            "editlocation": data.unit ? data.location.location_id + ',' + unit : data.location.location_id,
            "editdate_time": date,
            "editComments": data.comments,
            "edittypeofSamples": data.type_of_samples,
            "edittypeofAnalysis": data.type_of_analysis,
            "editfileName": this.pictureData(data.picture),
            "editpictureFile": data.picture,
            "editbatchNumber": data.batch_no,
            "editbarcode": data.barcode,
            "editreferenceGenome": data.reference_genome,
            "isDisable": true,
            "edit": true
        })
    }

    getLocations = () => {
        let locations = this.props.locationList
        let arr = []
        if ((this.state.building && this.state.floor) || (this.state.editbuilding && this.state.editfloor)) {
            if (locations) {
                for (let i = 0; i < locations.length; i++) {
                    if (locations[i].unit) {
                        arr.push(<option value={locations[i].location_id + ',' + locations[i].unit.id}>
                            {locations[i].room.room_name + ', ' + locations[i].unit.description}
                        </option>)
                    }
                    else {
                        arr.push(<option value={locations[i].location_id}>{locations[i].room.room_name}</option>)
                    }
                }
            }
        }
        return arr
    }
    getFileName = () => {
        let Filename = "Samples_" + moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
        this.setState({ fileName: Filename })
    }
    getTemplateName = () => {
        let templateName = "Samples_" + moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
        this.setState({ fileName: templateName })
    }
    onChangeFile = event => {
        let allowedExtensions = ["xlsx", "csv"]
        let file = event.target.files
        if (file.length > 0 && !allowedExtensions.includes(file[0].name.split('.').slice(-1)[0])) {
            appInsights.trackTrace({ message: "Incorect file format, Please choose an Excel file (.xlsx)", properties: { page: "sample" }, severityLevel: SeverityLevel.Verbose })
            toast.warn("Incorect file format, Please choose an Excel file (.xlsx)", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
        else {
            file[0]['displayName'] = file[0].name.split(".")[0];
            if (file[0]['displayName'].length > 17) file[0]['displayName'] = file[0]['displayName'].substring(0, 17) + '...';
            this.setState({ sampleFile: file[0] });
        }
    }
    handleLocationScan = () => {
        this.setState({ isLocationScan: true })
        if (sampleScanRef) {
            window.scrollTo(0, sampleScanRef.current.offsetTop)
        }
    }
    handleBarCodeScan = () => {
        this.setState({ isBarcodeScan: true })
        if (barCodeScanRef) {
            window.scrollTo(0, sampleScanRef.current.offsetTop)
        }
    }
    singleResultUpload = (sample_result, sample_barcode) => {
        this.setState({ loader: true });

        let jsonData;
        if (this.state.rowSampleID?.type_of_analysis === 'Microbiome') {
            const biomeResult = {};
            this.state.microbiomeOrganisms.forEach(o => {
                if (o.name.trim()) biomeResult[o.name.trim()] = o.percentage;
            });
            jsonData = {
                'analysis_result_data': { result: biomeResult },
                'barcode': sample_barcode,
            };
        } else {
            const c = this.state.selectedCriterion;
            jsonData = { 'barcode': sample_barcode };

            if (c) {
                jsonData.criterion = c.id;
                jsonData.program = c.program?.id;
                if (c.unit?.id) jsonData.measurement_unit = c.unit.id;

                if (c.operator === 'absence' || c.operator === 'presence') {
                    jsonData.avaliacao = this.state.otherResult;
                    jsonData.other_analysis = this.state.otherResult === 'Ausência' ? 'Negative' : 'Positive';
                } else {
                    jsonData.numerical_value = parseFloat(this.state.numericResult);
                    jsonData.other_analysis = this.previewVerdict() === 'Aprovado' ? 'Negative' : 'Positive';
                }
            } else {
                jsonData.other_analysis = sample_result;
            }
        }

        this.props.singleResultUpload(jsonData).then((res) => {
            if (res && res.data) {
                this.setState({
                    isConfirmResultModalOpen: false,
                    loader: false,
                    microbiomeOrganisms: [{ name: '', percentage: '' }],
                    selectedCriterion: null,
                    numericResult: '',
                    otherResult: null
                });
                toast.success("Result Added Successfully", { position: toast.POSITION.BOTTOM_RIGHT });
                this.props.downloadSampleData();
            }
        });
    }
    uploadSamples = () => {
        if (!this.state.sampleFile) {
            let message = "Samples Upload failed. Please choose a file!"
            if (appInsights && appInsights.trackTrace) {
                appInsights.trackTrace({ message: message, properties: { page: "sample" }, severityLevel: SeverityLevel.Verbose })
            }
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
        else {
            this.setState({ loader: true })
            this.props.uploadSamples(this.state.sampleFile).then((res) => {
                if (res && res.data) {
                    this.setState({ loader: false, isUploadModalOpen: false, sampleFile: "" })
                    this.props.downloadSampleData()
                    let total = res.data.number_of_samples_uploaded + res.data.number_of_invalids + res.data.number_of_duplicates
                    let uploaded = res.data.number_of_samples_uploaded
                    let message = (uploaded) + " out of " + (total) + " samples uploaded sucessfully."
                    if (appInsights) {
                        if (appInsights.trackEvent) {
                            appInsights.trackEvent({ name: 'Samples Uploaded', properties: { uploaded: uploaded, invalid: res.data.number_of_invalids, duplicates: res.data.number_of_duplicates } });
                        }
                        if (appInsights.trackTrace) {
                            appInsights.trackTrace({ message: 'Samples Uploaded', properties: { uploaded: uploaded, invalid: res.data.number_of_invalids, duplicates: res.data.number_of_duplicates }, severityLevel: SeverityLevel.Information })
                        }
                    }
                    toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT });
                    if (res.status === 203) {
                        message = "Found " + (res.data.number_of_invalids) + " samples with invalid data."
                        toast.warn(message, { position: toast.POSITION.BOTTOM_RIGHT })
                    }
                    else if (res.status === 202) {
                        message = "Found " + (res.data.number_of_duplicates) + " duplicate barcodes."
                        toast.warn(message, { position: toast.POSITION.BOTTOM_RIGHT })
                    }
                }
            }).catch((e) => {
                this.setState({ loader: false })
                if (e.response?.status === 400) {
                    let message = ''
                    if (e.response.data['invalid_headers'] || e.response.data['result_headers'] || e.response.data['barcode'])
                        message = "Upload failed due to invalid headers, please refer the template for more updates!!"
                    else if (e.response.data['empty_data'])
                        message = "Upload failed due to empty data in the file!!"
                    else if (e.response.data['number_of_invalids'])
                        message = "Upload failed due to invalid sample data!!"
                    else if (e.response.data['number_of_duplicates'] > 0 && e.response.data['number_of_samples_uploaded'] === 0)
                        message = "All samples in this file already exist in the database."
                    else
                        message = "Upload failed, try again after rechecking the data!!"
                    if (appInsights && appInsights.trackTrace) {
                        appInsights.trackTrace({ message: message, properties: { file: this.state.sampleFile, page: 'sample', error: e }, severityLevel: SeverityLevel.Error })
                    }
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    })
                }
                else {
                    let message = "Upload failed due to an unexcpected error!!."
                    if (appInsights && appInsights.trackTrace) {
                        appInsights.trackTrace({ message: message, properties: { file: this.state.sampleFile, page: 'sample', error: e }, severityLevel: SeverityLevel.Error })
                    }
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    })
                }
            })
        }
    }
    clearUpload = () => {
        this.setState({ sampleFile: undefined });
    }
    toggleUploadModal = () => {
        this.setState(prevState => ({
            isUploadModalOpen: !prevState.isUploadModalOpen,
        }));
    }
    handleError = (err) => {
        console.error(err)
    }


    customFilter = ({ field, filter, onChange }) => {
        let filterStyle = { menuPortal: base => ({ ...base, zIndex: 9999 }) }
        switch (field) {
            case 'is_result_generated':
                return (
                    <Select
                        className="custom-filters-select"
                        placeholder="Select"
                        onChange={entry => {
                            this.setState({ filterStatus: entry })
                            entry && entry.length > 0 ?
                                this.onFilteredChangeCustom(
                                    entry.map(o => {
                                        return o.value;
                                    })
                                    ,
                                    "is_result_generated"
                                )
                                :
                                this.onFilteredChangeCustom("", "is_result_generated")
                        }}
                        menuPortalTarget={document.body}
                        styles={filterStyle}
                        value={this.state.filterStatus}
                        isMulti={true}
                        options={this.props.downloadsamples.map(item => {
                            return item.is_result_generated
                        })
                            .filter((item, i, s) => s.lastIndexOf(item) === i).map((o, i) => {
                                let result
                                o ? result = 'Result Arrived' : result = 'Waiting'
                                return { id: i, value: o, label: result };
                            })}
                    />
                );
            case "location_id":
                return (
                    <Select
                        className="custom-filters-select"
                        placeholder="Select"
                        onChange={entry => {
                            this.setState({ filterLocation_id: entry });
                            entry && entry.length > 0 ?
                                this.onFilteredChangeCustom(
                                    entry.map(o => {
                                        return o.value;
                                    })
                                    ,
                                    "location_id"
                                ) :
                                this.onFilteredChangeCustom('', "location_id")
                        }}
                        menuPortalTarget={document.body}
                        styles={filterStyle}
                        value={this.state.filterLocation_id}
                        isMulti={true}
                        options={this.props.downloadsamples.map(item => {
                            return item.location.location_id
                        })
                            .filter((item, i, s) => s.lastIndexOf(item) === i).map((o, i) => {
                                return { id: i, value: o, label: o };
                            })}
                    />
                )
            case "organism":
                return (
                    <Select
                        className="custom-filters-select"
                        placeholder="Select"
                        onChange={entry => {
                            this.setState({ filterOrganism: entry })
                            entry && entry.length > 0 ?
                                this.onFilteredChangeCustom(
                                    entry.map(o => {
                                        return o.value;
                                    })
                                    ,
                                    "organism"
                                )
                                :
                                this.onFilteredChangeCustom("", "organism")
                        }}
                        menuPortalTarget={document.body}
                        styles={filterStyle}
                        value={this.state.filterOrganism}
                        isMulti={true}
                        options={this.props.downloadsamples.map(item => {
                            return item.organism
                        })
                            .filter((item, i, s) => s.lastIndexOf(item) === i).map((o, i) => {
                                return { id: i, value: o, label: o };
                            })}
                    />
                )
            case 'type_of_samples':
                return (
                    <Select
                        className="custom-filters-select"
                        placeholder="Select"
                        onChange={entry => {
                            this.setState({ filterType_of_samples: entry });
                            entry && entry.length > 0 ? this.onFilteredChangeCustom(
                                entry.map(o => {
                                    return o.value;
                                }),
                                "type_of_samples"
                            ) :
                                this.onFilteredChangeCustom('', "type_of_samples")
                        }}
                        menuPortalTarget={document.body}
                        styles={filterStyle}
                        value={this.state.filterType_of_samples}
                        isMulti={true}
                        options={this.props.downloadsamples.map(item => {
                            return item.type_of_samples
                        })
                            .filter((item, i, s) => s.lastIndexOf(item) === i).map((o, i) => {
                                return { id: i, value: o, label: o };
                            })}
                    />
                )
            case 'type_of_analysis':
                return (
                    <Select
                        className="custom-filters-select"
                        onChange={entry => {
                            this.setState({ filterType_of_analysis: entry });
                            entry && entry.length > 0 ? this.onFilteredChangeCustom(
                                entry.map(o => {
                                    return o.value;
                                }),
                                "type_of_analysis"
                            ) :
                                this.onFilteredChangeCustom('', "type_of_analysis")
                        }}
                        menuPortalTarget={document.body}
                        styles={filterStyle}
                        placeholder="Select"
                        value={this.state.filterType_of_analysis}
                        isMulti={true}
                        options={this.props.downloadsamples.map(item => {
                            return item.type_of_analysis
                        })
                            .filter((item, i, s) => s.lastIndexOf(item) === i).map((o, i) => {
                                return { id: i, value: o, label: o };
                            })}
                    />
                )
            case 'reference_genome':
                return (
                    <Select
                        className="custom-filters-select"
                        placeholder="Select"
                        onChange={entry => {
                            this.setState({ filterReference_genome: entry });
                            entry && entry.length > 0 ?
                                this.onFilteredChangeCustom(
                                    entry.map(o => {
                                        return o.value;
                                    }),
                                    "reference_genome",
                                ) :
                                this.onFilteredChangeCustom('', "reference_genome")
                        }}
                        menuPortalTarget={document.body}
                        styles={filterStyle}
                        value={this.state.filterReference_genome}
                        isMulti={true}
                        options={this.props.downloadsamples.map(item => {
                            return item.reference_genome
                        })
                            .filter((item, i, s) => s.lastIndexOf(item) === i).map((o, i) => {
                                return { id: i, value: o, label: o };
                            })}
                    />
                )
            default:
                return <Select />
        }
    };

    onFilteredChangeCustom = (value, accessor) => {
        let filtered = [...this.state.filtered];
        let filterCount = 0;
        if (filtered.length > 0) {
            filtered.forEach((filter, i) => {
                if (filter["id"] === accessor) {
                    if (value === "" || !!(value && value.length)) filtered.splice(i, 1);
                    else return filter["value"] = value;
                }
            });
        }
        filtered.push({ id: accessor, value: value });
        this.setState({ filtered: filtered }
            , () => this.forceUpdate());
        if (filtered.length > 0) {
            filtered.forEach((filter) => {
                if (typeof (filter["value"]) === "string" && filter["value"].length > 0) {
                    filterCount = filterCount + 1
                }
                else {
                    filterCount = filterCount + filter["value"].length
                }
            });
            this.setState({
                filterCount: filterCount
            })
        }
    };
    resetFilters = () => {
        this.setState({
            filterCount: 0,
            filterStatus: [],
            filtered: [],
            filterLocation_id: [],
            filterOrganism: [],
            filterType_of_samples: [],
            filterType_of_analysis: [],
            filterReference_genome: [],
        })
    }

    setResults = (input, result) => {
        if (input == "location")
            this.setState({ location: result, isLocationScan: false });
        else if (input == "barcode")
            this.setState({ barcode: result, isBarcodeScan: false })
    }

    render() {
        const windowWidth = this.state.windowWidth
        return (
            <>
                {windowWidth < mobileWidth &&
                    <div className="sample-overview-mob-tab" data-tut="reactour__sample">
                        <div className="samples-page-mob-tab">
                            <div className="fields">
                                <div className="sample-heading">Add a Sample</div>
                                <Row form>
                                    <Col >
                                        <Input className="sample-inputs" type="text" name="location" ref={sampleScanRef} id="Location" size="10" value={this.state.location} onChange={this.handleChange} placeholder="LocationId" />
                                        <div ref={sampleScanRef} className={this.state.isLocationScan ? "location-scan-on" : "location-scan-off"}>
                                            {this.state.isLocationScan &&
                                                <>
                                                    <canvas className="drawingBuffer" />
                                                    <h1 className="code-text" >Align the code within the frame to scan</h1>
                                                    {this.state.isLocationScan ? <Scanner scannerRef={sampleScanRef}
                                                        onDetected={(result) => this.setResults("location", result)}
                                                    /> : null}
                                                </>
                                            }

                                        </div>
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col >
                                        <div className="boxed">
                                            <Label for="scanCode" className={this.state.isLocationScan ? "active-code" : ""} onClick={() => { this.handleLocationScan() }}>Scan Code</Label>
                                            <Label for="typeCode" className={!this.state.isLocationScan ? "active-code" : ""} onClick={() => { this.setState({ isLocationScan: false }) }}>Type Code</Label>
                                        </div>
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col >
                                        <InputGroup className="sample-inputs">
                                            <Input className="sample-inputs-info" type="text" name="barcode" id="EF Barcode" size="10" ref={barCodeScanRef} value={this.state.barcode} onChange={this.handleChange} placeholder="EF Barcode*" />
                                            <InputGroupAddon id="EFBarcodeicon" addonType="append">
                                                <FontAwesomeIcon icon={faInfoCircle} id="EFBarcodeicon" className='barcode-tooltip-icon demo-icon' />
                                                <CustomToolTip placement="top" target="EFBarcodeicon" hide={false} text="This is the barcode generated by Eurofins for your order" />
                                            </InputGroupAddon>
                                        </InputGroup>

                                        <div ref={barCodeScanRef} className={this.state.isBarcodeScan ? "location-scan-on" : "location-scan-off"}>
                                            {this.state.isBarcodeScan &&
                                                <>
                                                    <canvas className="drawingBuffer" />
                                                    <h1 className="code-text" >Align the code within the frame to scan</h1>
                                                    {this.state.isBarcodeScan ?
                                                        <Scanner scannerRef={barCodeScanRef}
                                                            onDetected={(result) => this.setResults("barcode", result)} /> : null}
                                                </>}
                                        </div>
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col >
                                        <div className="boxed">
                                            <Label for="scanCode" className={this.state.isBarcodeScan ? "active-code" : ""} onClick={() => { this.handleBarCodeScan() }}>Scan Code</Label>
                                            <Label for="typeCode" className={!this.state.isBarcodeScan ? "active-code" : ""} onClick={() => { this.setState({ isBarcodeScan: false }) }}>Type Code</Label>
                                        </div>
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col >
                                        <div>
                                            <DatePicker id="date-time" onChange={this.onChange} selected={this.state.date_time}
                                                filterDate={(date) => {
                                                    return moment() > date;
                                                }}
                                                placeholderText="Date*"
                                                showTimeSelect
                                                maxDate={new Date()}
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                timeFormat="HH:mm"
                                                timeIntervals={15}
                                                timeCaption="time"
                                                className="date form-control sample-inputs"
                                                wrapperClassName="datepicker-wrapper"
                                                popperClassName="datepicker-popper"
                                                dateFormat="MMMM d, yyyy HH:mm"
                                                dateFormatCalendar=" "
                                                popperModifiers={{
                                                    preventOverflow: {
                                                        enabled: true,
                                                    },
                                                }}
                                                portalId='root'
                                                popperProps={{
                                                    positionFixed: true
                                                }}
                                            />
                                            <FontAwesomeIcon className='time-icon' icon={faCalendar} size="lg" />
                                        </div>
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col>
                                        <Input className="sample-inputs" type="select" name="typeofAnalysis" id="AnalysisType" value={this.state.typeofAnalysis} onChange={this.handleChange}>
                                            <option value="" default>Type of Analysis</option>
                                            <optgroup label="Molecular">
                                                <option value="SNP">SNP</option>
                                                <option value="cgMLST">cgMLST</option>
                                                <option value="Microbiome">Microbiome</option>
                                                <option value="Other">Other</option>
                                            </optgroup>
                                            <optgroup label="Monitoramento Ambiental - Qualitativo">
                                                <option value="Salmonella spp">Salmonella spp</option>
                                                <option value="Listeria monocytogenes">Listeria monocytogenes</option>
                                                <option value="Listeria spp">Listeria spp</option>
                                                <option value="Estafilococos coagulase Positiva">Estafilococos coagulase Positiva</option>
                                                <option value="Escherichia coli">Escherichia coli</option>
                                                <option value="Enterobacterias">Enterobacterias</option>
                                            </optgroup>
                                            <optgroup label="Monitoramento Ambiental - Quantitativo">
                                                <option value="Contagem Total de Mesófilos">Contagem Total de Mesófilos</option>
                                                <option value="Bolores e Leveduras">Bolores e Leveduras</option>
                                                <option value="Bacillus cereus">Bacillus cereus</option>
                                                <option value="Coliformes Totais">Coliformes Totais</option>
                                            </optgroup>
                                        </Input>
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col >
                                        <Input disabled={this.state.typeofAnalysis === "Microbiome"} className="sample-inputs" type="text" name="organism" id="Organism" size="10" value={this.state.organism} onChange={this.handleChange} placeholder="Organism*" />
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col >
                                        <Input disabled={this.state.typeofAnalysis !== "SNP" || this.state.typeofAnalysis === "Microbiome"} className="sample-inputs" type="text" name="referenceGenome" id="referenceGenome" size="10" value={this.state.typeofAnalysis !== "SNP" ? "" : this.state.referenceGenome} onChange={this.handleChange} placeholder="Reference Genome*" />
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col >
                                        <Input className="sample-inputs" type="text" name="typeofSamples" id="SampleType" size="10" value={this.state.typeofSamples} onChange={this.handleChange} placeholder="Type of Sample" />
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col >
                                        <Input className="sample-inputs" type="text" name="batchNumber" id="BatchNo" size="10" value={this.state.batchNumber} onChange={this.handleChange} placeholder="Batch Number" />
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col >
                                        <Input className="sample-inputs" type="text" name="comments" id="Comments" size="10" value={this.state.comments} onChange={this.handleChange} placeholder="Comments" />
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col className="upload-sample-input">
                                        <img src={uploadIcon} id="image-upload-label" alt='' />
                                        <input
                                            type="file"
                                            id="samplePicture"
                                            className="upload-file sample-inputs"
                                            accept=".png,.jpg, .jpeg"
                                            onChange={(e) => this.handleFileChange(e)}
                                            data-title={this.state.picturefileName || 'Upload Image'}
                                        />
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col md={8} className="button-align" >
                                        <Button className="clear-filter-button button-size cancel-buttons" id="resetButton" outline color="secondary" type="reset" onClick={this.resetData}>CLEAR</Button>
                                        <Button className="apply-button button-size" id="saveButton" type="submit" outline color="secondary" onClick={this.saveData}>SAVE</Button>

                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                }
                {windowWidth < mobileWidth &&
                    <div className="samples-page">
                        <div className="sample-overview" data-tut="reactour__sample">
                            <div className="sample-grid-mobile">
                                <div>
                                    {this.props.sampleList.length > 0 ?
                                        <Card>
                                            <CardHeader className="overview">Recently Created Sample
                                                <span className="sample-header-moblie">
                                                    <span className='sample-options-moblie' onClick={(e) => this.toggleEditModal(this.props.sampleList[0])}><img src={editIcon} className='sample-svg-paddding' alt='' />Edit</span>
                                                    <span className='sample-options-moblie' onClick={(e) => this.handleButtonClick(e, this.props.sampleList[0])}><img src={deleteIcon} className='sample-svg-paddding' alt='' />Delete</span>
                                                    {this.props.downloadsamples && this.props.downloadsamples.length > 0 &&
                                                        <div style={{ display: "none" }} element={<Button id="export-data-button" className="export-data-button" onClick={this.getFileName}><img src={downloadIcon} className='sample-svg-paddding' alt='' />Download</Button>} filename={this.state.fileName}>
                                                            {this.props.downloadsamples && this.props.downloadsamples.length > 0 ?
                                                                <div data={this.props.downloadsamples} name="Samples">
                                                                    <div label="Status" value={(col) => col.is_result_generated ? "Result Arrived" : "Waiting"} />
                                                                    <div label="SampleID" value={(col) => col.sample_id} />
                                                                    <div label="BarCode" value={(col) => col.barcode} />
                                                                    <div label="BatchNumber" value={(col) => col.batch_no} />
                                                                    <div label="LocationID" value={(col) => col.unit ? col.location.location_id + "," + col.unit.unit_id : col.location.location_id} />
                                                                    <div label="DateTime" value={(col) => moment(col.date_time).format('MMMM D, YYYY HH:mm')} />
                                                                    <div label="OrganismName" value={(col) => col.organism} />
                                                                    <div label="TypeOfSample" value={(col) => col.type_of_samples} />
                                                                    <div label="TypeOfAnalysis" value={(col) => col.type_of_analysis} />
                                                                    <div label="ReferenceGenome" value={(col) => col.reference_genome} />
                                                                    <div label="Comments" value={(col) => col.comments} />
                                                                </div>
                                                                : null
                                                            }
                                                        </div>}
                                                </span>
                                            </CardHeader>
                                            <CardBody className="tablet-sample-list">
                                                <CardText>
                                                    <table width="100%" cellPadding="5px">
                                                        <tbody>
                                                            <tr>
                                                                <td width="50%" >
                                                                    EF Barcode
                                                                </td>
                                                                <td width="1%">:</td>
                                                                <td width="49%" className='sample-value-moblie'>
                                                                    {this.props.sampleList[0] && this.props.sampleList[0].barcode}
                                                                </td>
                                                            </tr>
                                                            <tr >
                                                                <td width="50%">
                                                                    Location
                                                                </td>
                                                                <td width="1%">:</td>
                                                                <td width="49%" className='sample-value-moblie'>
                                                                    {this.props.sampleList[0] && this.props.sampleList[0].location && this.props.sampleList[0].location.location_id}
                                                                </td>
                                                            </tr>
                                                            <tr clasName="sample-list-table">
                                                                <td width="50%">
                                                                    Sample Type
                                                                </td>
                                                                <td width="1%">:</td>
                                                                <td width="49%" className='sample-value-moblie'>
                                                                    {this.props.sampleList[0] && this.props.sampleList[0].type_of_samples}
                                                                </td>
                                                            </tr>
                                                            <tr clasName="sample-list-table">
                                                                <td width="50%">
                                                                    Date & Time
                                                                </td>
                                                                <td width="1%">:</td>
                                                                <td width="49%" className='sample-value-moblie'>
                                                                    {this.props.sampleList[0] && this.props.sampleList[0].date_time && moment(this.props.sampleList[0].date_time).format('MMMM D, YYYY HH:mm')}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </CardText>
                                            </CardBody>
                                        </Card>
                                        :
                                        null
                                    }
                                </div>
                            </div>
                        </div></div>}
                <div className="samples-page page-layout">
                    <NavBar />
                    {windowWidth >= mobileWidth &&
                        <div className={"grid-data" + (windowWidth > 900 ? " samples-grid-data" : "")}>
                            <Row className="sample-list-header samples-page" form>
                                <Navbar className="navbar-results" light expand="md">
                                    <Nav navbar data-tut="reactour__nav">
                                        <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/samples/floormap/"><span className="nav-col"><img src={eyeIcon} className="nav-icons" alt='' />Floor View</span></NavLink>
                                        <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/samples/addsamples/"><span className="nav-col"><img src={listIcon} className="nav-icons" alt='' />List of Samples</span></NavLink>
                                    </Nav>
                                </Navbar>
                                <Col className="samples-header-right">
                                    <div className='dropdown-filter' onClick={this.state.filterCount > 0 ? this.resetFilters : this.toggle}>
                                        <img src={this.state.isFilterEnabled ? this.state.filterCount > 0 ? filterClearIcon : filterOffIcon : filterOnIcon} className="sample-svg-paddding" alt='' />
                                        <span className='samples-header-options'>{this.state.isFilterEnabled ? this.state.filterCount > 0 ? "Clear Filter" : "Hide Filter" : "Filter"}</span>
                                    </div>
                                    <div className={'dropdown-filter' + (this.state.checked.length > 0 ? "" : " samples-options-disabled")} data-tut="reactour__tableDelete" onClick={this.state.checked.length > 0 ? this.toggleMultiDeleteModal : undefined}>
                                        <img src={deleteIcon} className="sample-svg-paddding" alt='' /><span className='samples-header-options'>Delete</span>
                                    </div>
                                    <div className={'dropdown-filter' + (this.state.checked.length === 1 ? "" : " samples-options-disabled")} data-tut="reactour__tableEdit" onClick={this.state.checked.length === 1 ? () => this.toggleEditModal(this.props.downloadsamples[this.state.checked[0]]) : undefined}>
                                        <img src={editIcon} className="sample-svg-paddding" alt='' /><span className='samples-header-options'>Edit</span>
                                    </div>
                                    {this.props.downloadsamples && this.props.downloadsamples.length > 0 &&
                                        <div style={{ display: "none" }} element={<Button id="export-data-button" className="export-data-button" data-tut="reactour__downloads" onClick={this.getFileName}><img src={downloadIcon} className="export-import-svg" alt='' />Download</Button>} filename={this.state.fileName}>
                                            {this.props.downloadsamples && this.props.downloadsamples.length > 0 ?
                                                <div data={this.props.downloadsamples} name="Samples">
                                                    <div label="Status" value={(col) => col.is_result_generated ? "Result Arrived" : "Waiting"} />
                                                    <div label="SampleID" value={(col) => col.sample_id} />
                                                    <div label="BarCode" value={(col) => col.barcode} />
                                                    <div label="BatchNumber" value={(col) => col.batch_no} />
                                                    <div label="LocationID" value={(col) => col.unit ? col.location.location_id + "," + col.unit.unit_id : col.location.location_id} />
                                                    <div label="DateTime" value={(col) => moment(col.date_time).format('MMMM D, YYYY HH:mm')} />
                                                    <div label="OrganismName" value={(col) => col.organism} />
                                                    <div label="TypeOfSample" value={(col) => col.type_of_samples} />
                                                    <div label="TypeOfAnalysis" value={(col) => col.type_of_analysis} />
                                                    <div label="ReferenceGenome" value={(col) => col.reference_genome} />
                                                    <div label="Comments" value={(col) => col.comments} />
                                                </div>
                                                : null
                                            }
                                        </div>
                                    }
                                    {!localStorage.getItem("guest") ?
                                        <Button data-tut="reactour__uploads"
                                            className="export-data-button"
                                            id="export-data-button"
                                            labelColor="#000"
                                            backgroundColor="#FFF"
                                            fullWidth={true}
                                            onClick={() => this.toggleUploadModal()}
                                        ><img src={uploadIcon} className="export-import-svg" alt='' />
                                            Upload Samples
                                        </Button> : null}
                                    <Modal isOpen={this.state.isUploadModalOpen} toggle={this.toggleUploadModal} size="lg">
                                        <ModalHeader toggle={this.toggleUploadModal} className="edit-popup">Upload Samples</ModalHeader>
                                        <ModalBody className="upload-body">
                                            <Row xs="2">
                                                <Col>
                                                    <FontAwesomeIcon className="overlay-upload-icon upload-sample-icon-position" icon={faUpload} size="lg" />
                                                    <Input
                                                        className="edit-input-values edit-input-values-file upload-sample-file"
                                                        type="file"
                                                        accept=".xlsx, .csv"
                                                        placeholder="please enter file"
                                                        onChange={this.onChangeFile}
                                                        onClick={(event) => {
                                                            event.target.value = null
                                                        }}
                                                        data-title={'Choose File'}
                                                    />
                                                </Col>
                                                <Col className="upload-sample-last">
                                                    {this.state.sampleFile ?
                                                        <Col className="upload-filename">
                                                            <Label className="title">{this.state.sampleFile.displayName}</Label>
                                                            <img src={deleteIconRed} className="overlay-upload-icon trash-icon" alt=''
                                                                onClick={this.clearUpload}
                                                            />
                                                        </Col> : <></>}
                                                </Col>
                                                <Col>
                                                    <div className="vertical-line"></div>
                                                    <a href={template} target="_blank" rel="noopener noreferrer" download={"Samples_Template_" + moment(new Date()).format('YYYY-MM-DD hh:mm:ss') + '.xlsx'}>
                                                        <Button type="submit" id="export-data-button" className="export-data-button sample-template-button">Download Sample Template</Button>
                                                    </a>
                                                    <div className="edit-popup">
                                                        <h5 className="modal-text lowertag">* are mandatory to fill</h5>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter className="float-sm-right bottom-options">
                                            <Button className="button-size custom-button cancel-button mr-2" outline color="secondary" onClick={this.clearUpload}>Clear</Button>
                                            <Button
                                                className="button-size custom-button save-upload-delete-button"
                                                id="export-data-button"
                                                labelColor="#000"
                                                backgroundColor="#FFF"
                                                fullWidth={true}
                                                onClick={() => this.uploadSamples()}
                                            >
                                                Save
                                            </Button>
                                            {this.state.loader ? <Spinner size="sm" color="primary" /> : null}
                                        </ModalFooter>
                                    </Modal>
                                </Col>
                            </Row>
                            {this.state.loaderSamples ?
                                <>
                                    <div className="loader-sample-oval"><Oval color="#243682" height={60} width={60} /></div>
                                    <div className="no-data-msg"> Please wait while we check for samples...</div>
                                </>
                                :
                                <>
                                    {this.props.downloadsamples.length > 0 ?
                                        <div className="sample-table-height" data-tut="reactour__table">
                                            <ReactTable className="Data-Table"
                                                PaginationComponent={Pagination}
                                                data={this.props.downloadsamples}
                                                columns={this.columns}
                                                minRows={0}
                                                sortable={false}
                                                getTheadFilterTrProps={() => {
                                                    return {
                                                        className: this.state.isFilterEnabled ? "" : "table-filter-disabled"
                                                    };
                                                }}
                                                filterable={true}
                                                showPagination={true}
                                                defaultPageSize={10}
                                                filtered={this.state.filtered}
                                                onFilteredChange={(filtered, column, value) => {
                                                    this.onFilteredChangeCustom(value, column.id || column.accessor)
                                                }}
                                                defaultFilterMethod={(filter, row) => {
                                                    const id = filter.pivotId || filter.id;
                                                    if (typeof filter.value === "object" && filter.value !== null) {
                                                        return row[id] !== undefined
                                                            ? filter.value.indexOf(row[id]) > -1
                                                            : true;
                                                    } else {
                                                        return row[id] !== undefined
                                                            ? String(row[id]).indexOf(filter.value) > -1
                                                            : true;
                                                    }
                                                }}
                                                getTrProps={(state, rowInfo) => {
                                                    if (rowInfo && rowInfo.row) {
                                                        return {
                                                            onClick: () => { this.handleCheckClick(rowInfo.index) },
                                                            className: this.state.checked.includes(rowInfo.index) ? "table-selected-row" : "",
                                                        }
                                                    } else {
                                                        return {}
                                                    }
                                                }
                                                }
                                            />
                                        </div>
                                        :
                                        <>
                                            {this.props.downloadsamples.length === 0 ?
                                                <div className="no-data-msg"> No Samples Available</div>
                                                : null
                                            }
                                        </>
                                    }
                                </>
                            }
                        </div>
                    }
                    {/* Have to check if the below Modal is used */}
                    <Modal isOpen={this.state.isDeleteModalOpen} toggle={this.toggleDeleteModal}>
                        <ModalHeader toggle={this.toggleDeleteModal} className="edit-popup">Delete Sample</ModalHeader>
                        <ModalBody>
                            Are you sure you want to delete the sample with id <i>{this.state.deleteSampleID}</i> ?
                            <div className="float-sm-right mt-3">
                                <Button className="custom-button cancel-button mr-2" outline color="secondary" onClick={this.toggleDeleteModal}>Cancel</Button>
                                <Button id="deleteButton" className="custom-button save-upload-delete-button" onClick={this.deleteSample}>Delete</Button>
                            </div>
                        </ModalBody>
                    </Modal>
                    <Modal isOpen={this.state.isMultiDeleteModalOpen} toggle={this.toggleMultiDeleteModal}>
                        <ModalHeader toggle={this.toggleMultiDeleteModal} className="edit-popup delete-title">
                            <FontAwesomeIcon className="warning-icon" icon={faExclamationTriangle} />
                            Delete Samples
                        </ModalHeader>
                        {this.state.checked.length > 1 ?
                            <ModalBody className="delete-popup-body">
                                Do you you want to delete the {this.state.checked.length} samples selected?
                            </ModalBody> :
                            <ModalBody className="delete-popup-body">
                                Do you you want to delete the {this.state.checked.length} samples selected?
                                {/* Do you want to delete the sample {this.state.checked.map((data) => this.props.downloadsamples[data].barcode)}? */}
                            </ModalBody>}
                        <ModalFooter className="float-sm-right mt-3 bottom-options delete-footer">
                            <Button className="custom-button cancel-button mr-2 custom-dimension" outline color="secondary" onClick={this.toggleMultiDeleteModal}>No</Button>
                            <Button id="deleteButton" className="custom-button save-upload-delete-button" onClick={this.deleteMultipleSamples}>Yes</Button>
                        </ModalFooter>
                    </Modal>
                    <Modal isOpen={this.state.isEditModalOpen} toggle={this.toggleEditModal}>
                        <ModalHeader toggle={this.toggleEditModal} className="edit-popup">Edit a Sample
                        </ModalHeader>
                        <ModalBody className="sample-edit-body">
                            <Form>
                                <FormGroup>
                                    <div>
                                        <Row form>
                                            <Col>
                                                <Label className="edit-label-names">Sample ID</Label>
                                                <Input className="edit-input-values" type="text" name="SampleId" size="10" disabled value={this.state.sample_id} onChange={this.handleChange} />
                                            </Col>
                                            <Col>
                                                <Label className="edit-label-names">EF Barcode <span className="required-icon">*</span></Label>
                                                <Input className="edit-input-values" type="text" name="editbarcode" size="10" value={this.state.editbarcode} onChange={this.handleChange} placeholder="Enter EF Barcode" />
                                            </Col>
                                        </Row>
                                    </div>
                                    <div>
                                        <Row form>
                                            <Col>
                                                <Label className="edit-label-names">Building <span className="required-icon">*</span></Label>
                                                <Input className="edit-input-values" type="select" name="editbuilding" value={this.state.editbuilding} onChange={this.handleChangeBuliding} size="1">
                                                    <option value="" default disabled>Building</option>
                                                    {this.props.buildingList.map((building, key) => {
                                                        return <option id={building.id} key={key} value={building.building_id}>{building.building_name}</option>
                                                    })}
                                                </Input>
                                            </Col>
                                            <Col>
                                                <Label className="edit-label-names">Floor <span className="required-icon">*</span></Label>
                                                <Input className="edit-input-values" type="select" name="editfloor" value={this.state.editfloor} onChange={this.handleChangeFloor} size="1">
                                                    <option value="" default disabled>Floor</option>
                                                    {this.props.floorsList.map((floor, key) => {
                                                        return <option id={floor.id} key={key} value={floor.id}>{floor.floor_name}</option>
                                                    })}
                                                </Input>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div>
                                        <Label className="edit-label-names" id="edit-location-label">Location <span className="required-icon">*</span></Label>
                                        <Input className="edit-input-values" id="editLocation" type="select" name="editlocation" value={this.state.editlocation} onChange={this.handleChange} size="1">
                                            <option value="" default disabled>Location</option>
                                            {this.getLocations()}
                                        </Input>
                                    </div>
                                    <div>
                                        <Row form>
                                            <Col md={6}>
                                                <Label className="edit-label-names">Organism <span className="required-icon">*</span></Label>
                                                <Input className="edit-input-values" id="editOrganism" type="text" name="editOrganism" size="10" value={this.state.editOrganism} onChange={this.handleChange} placeholder="Enter Organism" />
                                            </Col>
                                            <Col md={.5}>
                                                <Label className="edit-label-names">Date & Time <span className="required-icon">*</span></Label>
                                                <div>
                                                    <DatePicker
                                                        id="edit-date-time"
                                                        className="form-control edit-input-values edit-date-time"
                                                        onChange={this.onChangeDate} selected={this.state.editdate_time}
                                                        filterDate={(date) => {
                                                            return moment() > date;
                                                        }}
                                                        showTimeSelect
                                                        maxDate={new Date()}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        wrapperClassName="datepicker-wrapper"
                                                        popperClassName="datepicker-popper"
                                                        timeFormat="HH:mm"
                                                        timeIntervals={15}
                                                        timeCaption="time"
                                                        dateFormat="MMMM d, yyyy HH:mm"
                                                        dateFormatCalendar=" "
                                                        popperModifiers={{
                                                            preventOverflow: {
                                                                enabled: true,
                                                            },
                                                        }}
                                                        portalId='root'
                                                        popperProps={{
                                                            positionFixed: true
                                                        }}
                                                    />
                                                    {/* <FontAwesomeIcon className='time-icon' icon={faCalendar} size="lg" /> */}
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div>
                                        <Row form>
                                            <Col>
                                                <Label className="edit-label-names" id="edit-location-label">Type of Analysis<span className="required-icon">*</span></Label>
                                                <Input className="sample-inputs" type="select" name="typeofAnalysis" id="AnalysisType" value={this.state.typeofAnalysis} onChange={this.handleChange}>
                                                    <option value="" default>Type of Analysis</option>
                                                    <optgroup label="Molecular">
                                                        <option value="SNP">SNP</option>
                                                        <option value="cgMLST">cgMLST</option>
                                                        <option value="Microbiome">Microbiome</option>
                                                        <option value="Other">Other</option>
                                                    </optgroup>
                                                    <optgroup label="Monitoramento Ambiental - Qualitativo">
                                                        <option value="Salmonella spp">Salmonella spp</option>
                                                        <option value="Listeria monocytogenes">Listeria monocytogenes</option>
                                                        <option value="Listeria spp">Listeria spp</option>
                                                        <option value="Estafilococos coagulase Positiva">Estafilococos coagulase Positiva</option>
                                                        <option value="Escherichia coli">Escherichia coli</option>
                                                        <option value="Enterobacterias">Enterobacterias</option>
                                                    </optgroup>
                                                    <optgroup label="Monitoramento Ambiental - Quantitativo">
                                                        <option value="Contagem Total de Mesófilos">Contagem Total de Mesófilos</option>
                                                        <option value="Bolores e Leveduras">Bolores e Leveduras</option>
                                                        <option value="Bacillus cereus">Bacillus cereus</option>
                                                        <option value="Coliformes Totais">Coliformes Totais</option>
                                                    </optgroup>
                                                </Input>
                                            </Col>
                                            <Col>
                                                <Label className="edit-label-names">Reference Genome *</Label>
                                                <Input disabled={this.state.edittypeofAnalysis !== "SNP"} id="editReferenceGenome" type="text" name="editreferenceGenome" className='edit-input-values' size="10" value={this.state.edittypeofAnalysis === "SNP" ? this.state.editreferenceGenome : ""} onChange={this.handleChange} placeholder="Reference Genome *" />
                                            </Col>
                                        </Row>
                                    </div>
                                    <div>
                                        <Row form>
                                            <Col>
                                                <Label className="edit-label-names">Batch Number</Label>
                                                <Input className="edit-input-values" type="text" name="editbatchNumber" id="batchNo" size="10" value={this.state.editbatchNumber} onChange={this.handleChange} placeholder="Enter Batch Number" />
                                            </Col>
                                            <Col>
                                                <Label className="edit-label-names">Type of Sample</Label>
                                                <Input className="edit-input-values" type="text" name="edittypeofSamples" id="type-of-sample" size="10" value={this.state.edittypeofSamples} onChange={this.handleChange} placeholder="Enter Sample Type" />
                                            </Col>
                                        </Row>
                                    </div>
                                    <div>
                                        <Label className="edit-label-names">Comments</Label>
                                        <Input type="textarea" id="editComments" name="editComments" className="edit-input-values" size="10" value={this.state.editComments} onChange={this.handleChange} placeholder="Enter Comments" />
                                    </div>
                                    <div>
                                        <Label className="edit-label-names">Upload Image</Label>
                                        <Input
                                            className="edit-input-values edit-input-values-file input-upload input-upload-align"
                                            type="file"
                                            accept="image/*"
                                            placeholder="please enter file"
                                            onChange={(e) => this.handleEditFileChange(e)}
                                            data-title={this.state.editfileName || 'Upload Image'}
                                        ></Input>
                                    </div>
                                </FormGroup>
                            </Form>

                            <div className="justify-content-between">
                                {this.state.type === "sample" ?
                                    <Button className="button-modal" outline color="danger" id={"deleteButton"} onClick={(e) => this.handleButtonClick(e)} >Delete
                                        <FontAwesomeIcon icon={faTrashAlt}></FontAwesomeIcon>
                                    </Button> : null}
                                <div className="float-right ml-auto">
                                    <Button className="button-cancel mr-2" outline color="secondary" type="reset" onClick={this.cancelData}>Cancel</Button>
                                    <Button className="button-size save-upload-delete-button" id="saveBtn" type="submit" onClick={this.handleEditBarcode}>Save</Button>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>
                    <Modal isOpen={this.state.isEditBarcodeModelOpen} toggle={this.toggleEditBarcodeModal}>
                        <ModalHeader toggle={this.toggleEditBarcodeModal} className="edit-popup">Edit a Sample</ModalHeader>
                        <ModalBody>
                            {this.state.warningMessage}
                            <div className="float-sm-right mt-3">
                                <Button className="custom-button cancel-button mr-2" outline color="secondary" onClick={this.toggleEditBarcodeModal}>Cancel</Button>
                                <Button id="deleteButton" className="custom-button save-upload-delete-button" onClick={this.saveData}>Proceed</Button>
                            </div>
                        </ModalBody>
                    </Modal>
                    <Modal isOpen={this.state.isOtherResultModalOpen} toggle={this.toggleOtherResult}>
                        <ModalHeader className="edit-popup" toggle={this.toggleOtherResult}>
                            Add result to a sample
                        </ModalHeader>
                        <ModalBody>
                            <div>
                                <Row>
                                    <Col>
                                        <Label className="edit-label-names">EF Barcode</Label>
                                        <Input className="edit-input-values" type="text" disabled value={this.state.rowBarcode} />
                                    </Col>
                                    <Col>
                                        <Label className="edit-label-names">Date & Time</Label>
                                        <Input className="edit-input-values" type="text" disabled value={this.state.rowDateTime} />
                                    </Col>
                                </Row>
                            </div>
                            <div>
                                <Row>
                                    <Col>
                                        <Label className="edit-label-names">Type of Sample</Label>
                                        <Input className="edit-input-values" type="text" disabled value={this.state.rowTypeOfSample} />
                                    </Col>
                                    <Col>
                                        <Label className="edit-label-names">Organism name</Label>
                                        <Input className="edit-input-values" type="text" disabled value={this.state.rowTypeOrganism} />
                                    </Col>
                                </Row>
                            </div>
                            <br />

                            {this.state.rowSampleID?.type_of_analysis === 'Microbiome' ? (
                                /* ── MICROBIOME: lista de organismos + % ── */
                                <div>
                                    <Label className="edit-label-names">Microbiome Results</Label>
                                    {this.state.microbiomeOrganisms.map((item, index) => (
                                        <Row key={index} style={{ marginBottom: '8px', alignItems: 'center' }}>
                                            <Col md={6}>
                                                <Input
                                                    className="edit-input-values"
                                                    type="text"
                                                    placeholder="Organism name"
                                                    value={item.name}
                                                    onChange={(e) => {
                                                        const updated = [...this.state.microbiomeOrganisms];
                                                        updated[index].name = e.target.value;
                                                        this.setState({ microbiomeOrganisms: updated });
                                                    }}
                                                />
                                            </Col>
                                            <Col md={4}>
                                                <Input
                                                    className="edit-input-values"
                                                    type="number"
                                                    placeholder="% abundance"
                                                    min="0"
                                                    max="100"
                                                    value={item.percentage}
                                                    onChange={(e) => {
                                                        const updated = [...this.state.microbiomeOrganisms];
                                                        updated[index].percentage = e.target.value;
                                                        this.setState({ microbiomeOrganisms: updated });
                                                    }}
                                                />
                                            </Col>
                                            <Col md={2}>
                                                {this.state.microbiomeOrganisms.length > 1 && (
                                                    <Button
                                                        color="danger"
                                                        size="sm"
                                                        outline
                                                        onClick={() => {
                                                            const updated = this.state.microbiomeOrganisms.filter((_, i) => i !== index);
                                                            this.setState({ microbiomeOrganisms: updated });
                                                        }}
                                                    >✕</Button>
                                                )}
                                            </Col>
                                        </Row>
                                    ))}
                                    <Button
                                        color="secondary"
                                        size="sm"
                                        outline
                                        style={{ marginTop: '4px' }}
                                        onClick={() => this.setState(prev => ({
                                            microbiomeOrganisms: [...prev.microbiomeOrganisms, { name: '', percentage: '' }]
                                        }))}
                                    >
                                        + Add organism
                                    </Button>
                                </div>
                            ) : (
                                <div>
                                    <Label className="edit-label-names">Critério de aceite (opcional)</Label>
                                    <Select
                                        className="custom-filters-select"
                                        placeholder="Selecione o programa / critério"
                                        isClearable={true}
                                        menuPortalTarget={document.body}
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        value={this.state.selectedCriterion
                                            ? { value: this.state.selectedCriterion.id, label: this.criterionLabel(this.state.selectedCriterion) }
                                            : null}
                                        options={(this.state.acceptanceCriteria || []).map(c => ({
                                            value: c.id, label: this.criterionLabel(c), data: c
                                        }))}
                                        onChange={(opt) => this.setState({
                                            selectedCriterion: opt ? opt.data : null,
                                            otherResult: null,
                                            numericResult: ''
                                        })}
                                    />

                                    {this.state.selectedCriterion && (
                                        <div style={{ margin: '10px 0', padding: '8px 12px', background: '#f4f6fb', borderRadius: '4px', fontSize: '13px' }}>
                                            <strong>{this.state.selectedCriterion.program?.test_name || ''}</strong>
                                            <div>{this.criterionRule(this.state.selectedCriterion)}</div>
                                        </div>
                                    )}

                                    <br />

                                    {this.state.selectedCriterion &&
                                        this.state.selectedCriterion.operator !== 'absence' &&
                                        this.state.selectedCriterion.operator !== 'presence' ? (
                                        <Row>
                                            <Col md={6}>
                                                <Label className="edit-label-names">Resultado numérico</Label>
                                                <Input
                                                    className="edit-input-values"
                                                    type="number"
                                                    step="any"
                                                    min="0"
                                                    placeholder="Digite o valor"
                                                    value={this.state.numericResult}
                                                    onChange={(e) => this.setState({ numericResult: e.target.value })}
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <Label className="edit-label-names">Unidade</Label>
                                                <Input className="edit-input-values" type="text" disabled
                                                    value={this.state.selectedCriterion.unit?.code || '-'} />
                                            </Col>
                                        </Row>
                                    ) : this.state.selectedCriterion ? (
                                        <div className="other-modal-radio" onClick={(event) => this.handleOther(event)}>
                                            <input type="radio" name="otherResult" value="Ausência" /><span>Ausência</span>
                                            <input type="radio" name="otherResult" value="Presença" /><span>Presença</span>
                                        </div>
                                    ) : (
                                        <div className="other-modal-radio" onClick={(event) => this.handleOther(event)}>
                                            <input type="radio" name="otherResult" value="Positive" /><span>Positive</span>
                                            <input type="radio" name="otherResult" value="Negative" /><span>Negative</span>
                                        </div>
                                    )}

                                    {this.previewVerdict() && (
                                        <div style={{
                                            marginTop: '12px', padding: '8px 12px', borderRadius: '4px',
                                            fontWeight: 600,
                                            color: this.previewVerdict() === 'Aprovado' ? '#1a7f37' : '#b42318',
                                            background: this.previewVerdict() === 'Aprovado' ? '#e6f4ea' : '#fdeceb'
                                        }}>
                                            {this.previewVerdict()}
                                        </div>
                                    )}
                                </div>
                            )}

                            <ModalFooter className="float-sm-right border-0">
                                <Button className="button-size custom-button cancel-button mr-2" outline color="secondary" onClick={() => this.toggleOtherResult()}>
                                    Cancel
                                </Button>
                                <Button
                                    className={"button-size custom-button save-upload-delete-button" + (this.isResultValid() ? "" : " samples-options-disabled")}
                                    onClick={() => this.toggleOtherResultSave()}
                                >
                                    Save
                                </Button>
                            </ModalFooter>
                        </ModalBody>
                    </Modal>
                    <Modal isOpen={this.state.isConfirmResultModalOpen} toggle={this.toggleOtherResultNo}>
                        <ModalHeader toggle={this.toggleOtherResultNo} className="edit-popup">Save Result!</ModalHeader>
                        <ModalBody className="delete-popup-body">
                            {this.state.rowSampleID?.type_of_analysis === 'Microbiome'
                                ? <>Save <span className='confirm-result'>{this.state.microbiomeOrganisms.length}</span> organism(s) to sample <span className='confirm-result'>{this.state.rowBarcode}</span>?</>
                                : <>Are you sure you want to save the result as <span className='confirm-result'>{this.state.selectedCriterion && this.state.numericResult !== '' ? this.state.numericResult : this.state.otherResult}</span> to <span className='confirm-result'>{this.state.rowBarcode}</span> Sample?</>
                            }
                        </ModalBody>
                        <ModalFooter className="float-sm-right mt-3 bottom-options delete-footer">
                            <Button className="custom-button cancel-button mr-2 custom-dimension" outline color="secondary" onClick={this.toggleOtherResultNo}>No</Button>
                            <Button id="deleteButton" className="custom-button save-upload-delete-button" onClick={() => this.singleResultUpload(this.state.otherResult, this.state.rowBarcode)}>Yes</Button>
                        </ModalFooter>
                    </Modal>

                    <ToastContainer autoClose={3000} />
                    {this.props.isTourOpen ? <Tour isOpen={this.props.isTourOpen} closeTour={this.props.closeTour} openTour={this.props.openTour} /> : null}
                </div>
            </>
        )
    }
}

const mapStateToProps = state => {

    return {
        downloadsamples: state.sample_data.downloadSampleData,
        sampleList: state.sample_data.sampleList,
        locationList: state.sample_data.locationList,
        samplePagination: state.sample_data.allPagination,
        buildingList: state.floor_data.buildingsList,
        floorsList: state.floor_data.floorsList,
        sampleParams: state.sample_data.sampleParams
    }
}

export default withAITracking(reactPlugin, connect(
    mapStateToProps,
    {
        fetchSamplesList,
        downloadSampleData,
        fetchLocationList,
        saveSample,
        updateSample,
        deleteSample,
        deleteMultipleSamples,
        fetchBuilding,
        fetchFloors,
        uploadSamples,
        singleResultUpload,
        fetchAcceptanceCriteria,
    }
)(Sample), 'Samples', 'Sample');